<template>
  <div class="d-flex flex-row align-items-center">
    <div
        class="new-progress-bar-container"
        :class="{
        'gray-bg': type === 'readiness',
        'loading-container': loading
      }"
        v-if="(barValue !== null && type !== 'proficiency') || loading"
    >
      <div v-if="loading" :class="['indeterminate-bar', getColorClass()]"></div>
      <template v-else>
        <div
            v-if="type === 'readiness'"
            :class="['progress-bar', getColorClass()]"
            :style="{ width: readBarWidth }"
        ></div>
      </template>
    </div>

    <span
        class="progress-value"
        :class="{ 'ml-2': barValue !== null }"
        style="margin-left: 8px; display: inline-block"
    >
      <span v-if="loading">...</span>
      <template v-else>
        <span
            v-if="type === 'readiness' && barValue == 0 && enableReadinessBar"
            style="white-space: nowrap"
        >
          0%
        </span>
        <span v-else-if="barValue !== null && enableReadinessBar"> {{ Math.round(barValue) }}% </span>
        <span v-else-if="barValue === null && type === 'readiness' && enableReadinessBar">No Data</span>
        <span v-else-if="barValue !== null && type === 'readiness' && !enableReadinessBar">0%</span>
      </template>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import "./readinessbar.css";

// Props definition
const props = defineProps({
  barValue: Number,
  maxValue: {
    type: Number,
    default: 150,
  },
  type: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: false
  },
  enableReadinessBar: {
    type: Boolean,
    default: true
  }
});

// Computed properties
const readBarWidth = computed(() => {
  const percentage = (props.barValue / props.maxValue) * 100;
  return `${Math.min(percentage, 100)}%`;
});

// Methods
const getColorClass = () => {
  if (props.loading) {
    return 'black-bg';
  }
  if (props.type === "readiness") {
    if (props.barValue >= 126 && props.barValue <= 150 && props.enableReadinessBar) {
      return `${props.type}-first-color`;
    } else if (props.barValue >= 101 && props.barValue < 126 && props.enableReadinessBar) {
      return `${props.type}-second-color`;
    } else if (props.barValue >= 76 && props.barValue < 101 && props.enableReadinessBar) {
      return `${props.type}-third-color`;
    } else if (props.barValue >= 50 && props.barValue < 76 && props.enableReadinessBar) {
      return `${props.type}-forth-color`;
    } else if (props.barValue >= 26 && props.barValue < 50 && props.enableReadinessBar) {
      return `${props.type}-fifth-color`;
    } else if (props.barValue >= 10 && props.barValue < 26 && props.enableReadinessBar) {
      return `${props.type}-sixth-color`;
    } else if (props.barValue >= 1 && props.barValue < 10 && props.enableReadinessBar) {
      return `${props.type}-sixth-color`;
    } else if (props.barValue >= 1 && props.barValue <= 150 && !props.enableReadinessBar) {
      return `${props.type}-disabled-color`;
    } else if (props.barValue === 0 && !props.enableReadinessBar) {
      return `${props.type}-zero-disabled-color`;
    } else {
      return "default-color";
    }
  }
};
</script>

<style scoped>
.new-progress-bar-container {
  display: flex;
  align-items: center;
}

.new-progress-bar-container .progress-value {
  font-size: 14px;
  margin-left: 8px;
}

.d-flex {
  display: flex;
}
.new-progress-bar-container.loading-container {
  position: relative;
  overflow: hidden;
}

.new-progress-bar-container .indeterminate-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 30%;
  animation: indeterminate-animation 1.5s infinite cubic-bezier(0.65, 0.815, 0.735, 0.395);
}

@keyframes indeterminate-animation {
  0% {
    left: -30%;
  }
  100% {
    left: 100%;
  }
}
</style>
